import { createSelector } from 'reselect';
import StarTitle from '@atlassian/jira-common-directory-v2/src/components/star-title-cell/view.tsx';
import {
	CHANGE_OWNER,
	COPY,
	EDIT,
	DELETE,
} from '@atlassian/jira-directory-base/src/model/operation-types.tsx';
import { NAME, POPULARITY, FAVOURITED, OWNER } from '../model/constants/sort-field.tsx';
import { getLoggedInUserAccountId } from '../state/selectors/app/index.tsx';
import AccessCell from './content/cells/access/index.tsx';
import EditCell from './content/cells/edit/index.tsx';
import FavoriteCell from './content/cells/favourite/index.tsx';
import OwnerCell from './content/cells/owner/index.tsx';
import PopularityWithActionsCell from './content/cells/popularity-with-actions/index.tsx';
import PopularityCell from './content/cells/popularity/index.tsx';
import TitleCell from './content/cells/title/index.tsx';
import ChangeOwnerModal from './content/change-owner-modal/index.tsx';
import CopyModal from './content/copy-modal/index.tsx';
import DeleteModal from './content/delete-modal/index.tsx';
import EditModal from './content/edit-modal/index.tsx';
import messages from './messages.tsx';

export const operationModals = {
	[COPY]: CopyModal,
	[EDIT]: EditModal,
	[DELETE]: DeleteModal,
	[CHANGE_OWNER]: ChangeOwnerModal,
} as const;

export const emptyFilterResultConfiguration = {
	message: messages.emptyFilterResultMessage,
} as const;

export const getTableConfiguration = createSelector(getLoggedInUserAccountId, (accountId) =>
	[
		accountId !== null
			? {
					title: StarTitle,
					Cell: FavoriteCell,
					sortField: FAVOURITED,
					width: 3,
					isIconOnlyHeader: true,
					ascendingSortTooltip: messages.starredToUnstarredOrder,
					descendingSortTooltip: messages.unstarredToStarredOrder,
				}
			: undefined,
		{
			title: messages.name,
			Cell: TitleCell,
			sortField: NAME,
			width: accountId ? 25 : 35,
			ascendingSortTooltip: messages.aToZOrder,
			descendingSortTooltip: messages.zToAOrder,
		},
		accountId !== null
			? {
					title: messages.owner,
					Cell: OwnerCell,
					sortField: OWNER,
					width: 19,
					ascendingSortTooltip: messages.aToZOrder,
					descendingSortTooltip: messages.zToAOrder,
				}
			: undefined,
		{
			title: messages.viewers,
			Cell: AccessCell,

			width: accountId ? 19 : 19.5,
		},
		{
			title: messages.editors,
			Cell: EditCell,
			width: accountId ? 19 : 25,
		},
		{
			title: messages.popularity,
			Cell: accountId !== null ? PopularityWithActionsCell : PopularityCell,
			sortField: POPULARITY,
			width: accountId !== null ? 15 : 9,
			ascendingSortTooltip: messages.lowestToHighestOrder,
			descendingSortTooltip: messages.highestToLowestOrder,
		},
	].filter(Boolean),
);

export const getTableLabel = () => messages.tableAriaLabel;

export const getResultsAnnouncerMessage = () => messages.filterResultsAnnouncement;
